/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


                app.service('statisticsService', ["$rootScope", function ($rootScope) {
                        var mitarbeiterGesamt = 0;
                        var mitarbeiterFree = 0;
                        var mitarbeiterReserved = 0;
                        var mitarbeiterFix = 0

                        var setCount = function (count) {
                            mitarbeiterGesamt = count
                            $rootScope.$emit("statisticChanged")
                        };

                        var getCount = function () {
                            return mitarbeiterGesamt;
                        };

                        var setFix = function (count)
                        {
                            mitarbeiterFix = count
                            $rootScope.$emit("statisticChanged")
                        }
                        var getFree = function () {
                            return mitarbeiterGesamt - ((+mitarbeiterFix) + (+mitarbeiterReserved));
                        };

                        var getFix = function () {

                            return  mitarbeiterFix
                        };

                        var setReserved = function (count) {
                            mitarbeiterReserved = count
                            $rootScope.$emit("statisticChanged")
                        };

                        var getReserved = function () {
                            return mitarbeiterReserved;
                        };

                        return {
                            setCount: setCount,
                            getCount: getCount,
                            getFree: getFree,
                            setReserved: setReserved,
                            getReserved: getReserved,
                            getFix: getFix,
                            setFix: setFix
                        };

                    }]);